import { get } from '../../utils/objectHelpers';
import MainComp from '../str-main/component';

const KEY = 'str-category-tree';
const CLS = {
    root: KEY,
    rootList: 'str-category-tree__list',
    allCatsLink: 'str-category-tree__all-cats-link'
};
const SEL = {
    rootList: `.${CLS.rootList}`
};

export default class {
    onInput(input) {
        return {
            categories: get(input, 'page.modules.STORE_CATEGORIES_MODULE.categories', []),
            heading: get(input, 'page.modules.STORE_CATEGORIES_MODULE.header.textSpans.0.text', ''),
            headingUrl: get(input, 'page.modules.STORE_CATEGORIES_MODULE.header.action.URL', ''),
            headingTracking: JSON.stringify(get(input,
                'page.modules.STORE_CATEGORIES_MODULE.header.action.trackingList', {}))
        };
    }
    onMount() {
        this.root = this.getEl(KEY);
        this.rootList = this.root.querySelector(SEL.rootList);
    }
    handleClick(evt) {
        evt.preventDefault();
        const button = evt.target.closest('button');
        const link = evt.target.closest('a');
        if (button) { // Open and close sub-categories
            const item = button.closest('li');
            toggleList(item);
        } else if (link) {
            const item = link.closest('li');
            loadCategoryView(link.href, evt);
            openList(item);
            closeOtherLists(item);
            this.boldLink(link);
            this.handleAllCatsClick(link);
        }
    }
    boldLink(targetLink) {
        // First un-bold all the links
        const links = this.root.querySelectorAll('a');
        for (let i = 0, n = links.length; i < n; i++) {
            links[i].classList.remove('bold');
        }
        // Bold the target link
        targetLink.classList.add('bold');
    }
    handleAllCatsClick(link) {
        // Close all lists when "All Categories" link is clicked
        if (link && link.classList.contains(CLS.allCatsLink)) {
            const rootItems = this.rootList.querySelectorAll(':scope > li');
            for (let i = 0, n = rootItems.length; i < n; i++) {
                closeList(rootItems[i]);
            }
        }
    }
}

function toggleList(item) {
    if (item) {
        if (item.getAttribute('aria-expanded') !== 'true') {
            openList(item);
            closeOtherLists(item);
        } else {
            closeList(item);
        }
    }
}

function loadCategoryView(href, evt) {
    MainComp.sendCategoryFilterEvent({
        url: href,
        clickEvent: evt
    });
}

function openList(item) {
    if (item) {
        const hasSublist = item.querySelector('ul');
        if (hasSublist) {
            item.setAttribute('aria-expanded', true);
            setAriaHiddenOnSublists(item, false);
        }
    }
}

// Close list and all sublists
function closeList(item) {
    if (item) {
        const hasSublist = item.querySelector('ul');
        if (hasSublist) {
            item.setAttribute('aria-expanded', false);
            setAriaHiddenOnSublists(item, true);

            const subItems = item.querySelectorAll('li');
            for (let i = 0, n = subItems.length; i < n; i++) {
                const subItem = subItems[i];
                subItem.setAttribute('aria-expanded', false);
                setAriaHiddenOnSublists(subItem, true);
            }
        }
    }
}

function setAriaHiddenOnSublists(item, isHide) {
    if (item) {
        const lists = item.querySelectorAll(':scope > ul');
        for (let i = 0, n = lists.length; i < n; i++) {
            lists[i].setAttribute('aria-hidden', isHide);
        }
    }
}

function closeOtherLists(item) {
    if (item) {
        const list = item.closest('ul');
        // Only act on items that are direct children of root list
        if (list.classList.contains(CLS.rootList)) {
            const items = list.querySelectorAll(':scope > li');
            for (let i = 0, n = items.length; i < n; i++) {
                if (items[i] !== item) {
                    closeList(items[i]);
                }
            }
        }
    }
}
